const e = {
  name: "UnifiedCommerce",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M37,18c0,4.6-2.1,9-5.8,11.8C30.1,27.6,27.7,26,25,26c-3.7,0-6.7,2.8-7,6.5C12.6,31,8.4,26.6,7.3,21
			c3.7-0.2,6.7-3.2,6.7-7c0-2.5-1.3-4.6-3.2-5.9C13.6,4.9,17.6,3,22,3c1.6,0,3.2,0.3,4.8,0.8c-0.5,1-0.8,2-0.8,3.2c0,3.9,3.1,7,7,7
			c1.2,0,2.2-0.3,3.2-0.8C36.7,14.8,37,16.4,37,18z M25,38c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5s5,2.2,5,5C30,35.8,27.8,38,25,38z
			 M2,14c0-2.8,2.2-5,5-5s5,2.2,5,5s-2.2,5-5,5S2,16.8,2,14z M33,2c2.8,0,5,2.2,5,5s-2.2,5-5,5s-5-2.2-5-5S30.2,2,33,2z M40,7
			c0-3.9-3.1-7-7-7c-2,0-3.7,0.8-5,2.1C26.1,1.4,24.1,1,22,1c-5.1,0-9.9,2.3-13.1,6.3C8.3,7.1,7.6,7,7,7c-3.9,0-7,3.1-7,7
			c0,3.3,2.2,6,5.2,6.8c1.1,6.8,6.2,12.2,12.9,13.8c0.7,3.1,3.5,5.5,6.8,5.5c3.9,0,7-3.1,7-7c0-0.4,0-0.8-0.1-1.2
			C36.3,28.6,39,23.5,39,18c0-2.1-0.4-4.1-1.1-6C39.2,10.7,40,9,40,7z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as UnifiedCommerce
};
